import fx from "../../utils/fx";
import AxiosInterceptor from "api/interceptor";

const logs = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return logs.get("/logs?" + qstr);
  },
  getTypes() {
    return logs.get("/logs/types?");
  },
};
